import React, { memo ,useRef,useState,useEffect } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import {Placeholder} from 'react-bootstrap';


import { FreeMode, Navigation, Thumbs,Pagination  } from 'swiper/modules';
import { useCart } from './CartContext';
import NumberFormatter from "./NumberFormatter";
import AccordionSection from "./AccordionSection";
import UseMediaQuery from "./UseMediaQuery";

import 'swiper/css'; 
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import "bootstrap/dist/js/bootstrap.bundle.min";



const ProductDetail = memo(({ Product = [], loading }) => {
    const isMobile = UseMediaQuery("(max-width: 768px)");

    const { loadingProductId, handleAddToCart } = useCart();
    const thumbsSwiperRef = useRef(null);
    const [thumbsSwiper, setthumbsSwiper] = useState(false);
    const [selectedAttribute, setSelectedAttribute] = useState({});
    
    const handleSelectattribute = (attr,location_code,price) => {
        setSelectedAttribute({
            id_product_attribute : attr,
            loc_code: location_code,
            price:price
        });
    };
    /*useEffect(() => {
        setSelectedAttribute({})
      }, []);*/
    const [activeIndex, setActiveIndex] = useState(0);
    let selectattr = false;
    console.log(Product);
    return(
       <>
        {loading?
            <div className="product-detail  mt-0 mt-md-5">
                {!isMobile ? (
                <div className='row container mx-auto px-0'>
                    
                    <div className="col-6">
                        <Placeholder as="h1" animation="glow">
                            <Placeholder xs={8} size="lg" />
                        </Placeholder>
                        <Placeholder className="price" animation="glow">
                            <Placeholder xs={5} size="lg" />
                        </Placeholder>
                        <div>
                        <Placeholder animation="glow">
                            <Placeholder xs={3} />
                        </Placeholder>
                        </div>
                        <Placeholder animation="glow">
                            <Placeholder.Button xs={8} className="btn add-to-cart mt-4 mx-4 p-3" />
                        </Placeholder>
                        <Placeholder animation="glow">
                            <Placeholder.Button xs={8} className="btn add-to-cart mt-3 mx-4 p-3" />
                        </Placeholder>
                    </div>
                    <div className="col-6 d-flex">
                        <div className="col-8 ms-2">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                        <div className="col-4">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                    </div>
                </div>):(
                    <>
                     <div className='row container m-0 px-0'>
                        <div className="col-12 p-0">
                            <div className="product-img-top">
                                <Placeholder animation="glow">
                                    <Placeholder xs={12} />
                                </Placeholder>
                            </div>
                        </div>
                    </div>
                    <div className='row container m-0 px-0'>
                        <div className="d-flex col-12 mt-3 w-100">
                            <Placeholder className="col-6 mx-1" animation="glow">
                                <Placeholder.Button xs={4} className="col-11 btn btn-plymouth-green border-0" />
                            </Placeholder>
                            <Placeholder className="col-6 mx-1" animation="glow">
                                <Placeholder.Button xs={4} className="col-11 btn btn-plymouth-green border-0" />
                            </Placeholder>
                        </div>
                        <div className="row container mt-3 mt-md-0">
                            <Placeholder className="product-title" animation="glow">
                                <Placeholder xs={5} />
                            </Placeholder>
                            <Placeholder className="price" animation="glow">
                                <Placeholder xs={4} />
                            </Placeholder>
                            <Placeholder className="price" animation="glow">
                                <Placeholder xs={3} />
                            </Placeholder>
                            
                        </div>
                    </div>
                    </>
                    )
                }
                <div className='add-to-cart-info p-4 text-center mt-5'>
                </div>
            </div>
            :
            <div className="product-detail mt-0 mt-md-5">
                {!isMobile ? (
                <div className='row container mx-auto px-0'>
                    
                    <div className="col-5">
                        <h1 className="product-title">{Product.name}</h1>
                        <span className="price"><NumberFormatter className='ms-2' amount={selectedAttribute.price? selectedAttribute.price:Product.price} locale ='en-us'/> ریال</span>
                        
        
                        <div style={{fontSize:'24px',fontWeight:'700',lineHeight:'29px',opacity:'.65'}}>% <span style={{letterSpacing:'16%',marginLeft:'15px'}}>{Product.webhesab_ojrate.ojrat}</span>  اجرت ساخت</div>
                        <div className="d-flex flex-column col-9 mt-4 w-100">
                            <button className="btn btn-outline text-center m-2 p-3"  data-bs-toggle="modal" data-bs-target="#galleryModal">برای مشاهده عکس با موبایل کلیک کنید</button>
                           
                            <button className="btn btn-outline text-center m-2 p-3">برای مشاهده ویدیو با موبایل کلیک کنید</button>
                        </div>
                    </div>
                   
                    <div className="col-7 d-flex">
                        {/* اسلایدر اصلی */}
                        <div className="col-10 ms-2">
                        <Swiper
                            direction="vertical"
                            slidesPerView={1.2}
                            spaceBetween={0}
                            thumbs={{
                                swiper:
                                thumbsSwiperRef.current &&
                                !thumbsSwiperRef.current.destroyed
                                    ? thumbsSwiperRef.current
                                    : null,
                            }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            lazy={{ loadPrevNext: true }} // فعال کردن Lazy Load
                            className="mainSwiper"
                        >
                            {Product.images &&
                            Product.images.map((image, index) => (
                                <SwiperSlide key={index}>
                                <img
                                    src={image.src}
                                    alt={`Product Image ${index}`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "100%",
                                    height: "auto",
                                    cursor: "pointer",
                                    }}
                                />
                                 <div className="swiper-lazy-preloader"></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        </div>
                        <div className="col-2">
                        {/* اسلایدر Thumbnail */}
                        
                        <Swiper
                            direction="vertical"
                            slidesPerView={5} // تعداد اسلایدهای قابل نمایش
                            spaceBetween={10} // فاصله بین اسلایدها
                            freeMode={true}
                            onSwiper={(swiper) => {
                                thumbsSwiperRef.current = swiper;
                                setthumbsSwiper(swiper);
                            }}
                            modules={[FreeMode, Navigation, Thumbs]}
                            lazy={{ loadPrevNext: true }}
                            className="thumbSwiper"
                        >
                        {Product.images &&
                            Product.images.map((image, index) => (
                                <SwiperSlide key={index} >
                                <img
                                    src={image.src}
                                    alt={`Thumbnail ${index}`}
                                    className="swiper-lazy"
                                    style={{
                                    width: "100%",
                                    height: "auto",
                                    cursor: "pointer",
                                    }}
                                />
                                 <div className="swiper-lazy-preloader"></div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                        </div>
                    </div>
                </div>
                ):( //موبایل
                    <> 
                    <div className='row container m-0 px-0'>
                        <div className="col-12 p-0">
                            <Swiper
                            slidesPerView={1}
                            modules={[FreeMode, Navigation,Pagination]}
                            pagination={{ clickable: true }}
                            lazy={{ loadPrevNext: true }} // فعال کردن Lazy Load
                            className="mainSwiper"
                            >
                                {Product.images &&
                                Product.images.map((image, index) => ( 
                                    <SwiperSlide key={index}>
                                    <img
                                        src={image.src}
                                        alt={`Product Image ${index}`}
                                        className="swiper-lazy"
                                        style={{
                                        width: "100%",
                                        height: "auto",
                                        cursor: "pointer",
                                        }}
                                    />
                                    <div className="swiper-lazy-preloader"></div>
                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>
                    </div>
                    <div className='container m-0 px-0'>
                            <div className="d-flex col-12 mt-2">
                                <button className="btn btn-plymouth-green text-center m-2 px-4 p-md-3"  data-bs-toggle="modal" data-bs-target="#galleryModal">برای مشاهده عکس با موبایل کلیک کنید</button>
                            
                                <button className="btn btn-plymouth-green text-center m-2 px-4 p-md-3">برای مشاهده ویدیو با موبایل کلیک کنید</button>
                            </div>
                        <div className="col-12 p-3 m-md-0">
                            <h1 className="product-title">{Product.name}</h1>
                            <span className="price"><NumberFormatter className='ms-2' amount={selectedAttribute.price? selectedAttribute.price:Product.price} locale ='en-us'/> ریال</span>
            
                            <div className='ojrat'>% {Product.webhesab_ojrate.ojrat} <span>اجرت ساخت</span></div>
                            
                        </div>
                   
                    </div>
                    </>
                    )
                }
                
                <div className='add-to-cart-info p-4 text-center'>
                {Product.quantity > 0 && (
                    <button 
                    className='btn add-to-cart'
                    onClick={() => handleAddToCart({
                        id_product : Product.id_product,
                        id_product_attribute : selectedAttribute.id_product_attribute,
                        loc_code:selectedAttribute.loc_code
                      })}
                    disabled={loadingProductId === Product.id_product}
                    >
                    {loadingProductId === Product.id_product && (
                        <span
                            className="spinner-border spinner-border-sm mx-1"
                            role="status"
                            aria-hidden="true"
                        ></span>
                    )}
                    افزودن به سبد خرید
                    </button>
                )}
             

                {Object.values(Product.groups).map((group, group_id) => (
                <div key={group_id} className="clearfix product-variants-item">
                  
                    {group.group_type === "select" ? (
                    <>
                        <h2 className="mt-4">موجودی شعب</h2>
                        <table className='attribute-ts mb-4'>
                        <thead>
                            <tr>
                            <th>انتخاب</th>
                            <th>وزن</th>
                            {Product.webhesab_addition_info.size && (
                                <th>سایز</th>
                            )}
                            <th>قیمت (ریال)</th>
                            <th>نام فروشگاه</th>
                            </tr>
                        </thead>
                        <tr className='space-tb'>
                            <td colSpan={4} ></td>
                        </tr>
                        <tbody>
                        
                        {Object.values(Product.webhesab_addition_info.references).map((reference,refindex)=>{
                           
                                if (["", 1, 6, 8].includes(Product.webhesab_addition_info.locations_code[reference])) {
                                    return null;
                                }
                               
                                if(selectedAttribute.id_product_attribute){
                                    selectattr = (selectedAttribute.id_product_attribute === Product.webhesab_addition_info.pr_attr[reference]);
                                }
                                else if(Product.webhesab_addition_info.atr[reference] == group.default){
                                        selectattr = true;
                                        
                                        setSelectedAttribute({
                                            id_product_attribute : Product.webhesab_addition_info.pr_attr[reference],
                                            loc_code: Product.webhesab_addition_info.locations_code[reference],
                                            price:Product.webhesab_addition_info.price[reference]
                                        });
                                        //handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference], Product.webhesab_addition_info.price[reference]);  
                                }
                                return (
                                    <tr key={refindex} onClick={() => handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference], Product.webhesab_addition_info.price[reference])}>
                                        <td> 
                                            <input
                                                type="radio"
                                                value={Product.webhesab_addition_info.pr_attr[reference]} 
                                                name="group"
                                                onChange={() => handleSelectattribute(Product.webhesab_addition_info.pr_attr[reference],Product.webhesab_addition_info.locations_code[reference],Product.webhesab_addition_info.price[reference])}
                                                checked={selectattr}
                                            />
                                        </td>
                                       
                                        <td style={{letterSpacing:'16%'}} className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.products_wight[reference]} 
                                        </td>
                                        {Product.webhesab_addition_info.size && (
                                        <td className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.size[reference]} 
                                        </td>)}
                                        <td style={{letterSpacing:'16%'}} className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            <NumberFormatter amount={Product.webhesab_addition_info.price[reference]} locale="en-US" />
                                        </td>
                                        <td className={selectattr ? 'selected-attr': 'hover-attr'}>
                                            {Product.webhesab_addition_info.locations_name[reference]}
                                        </td>
                                    </tr>
                                );
                            }
                        )}
                        </tbody>
                        </table>
                    </>
                    ) : (
                    <div></div>
                    )}
                </div>
                ))}
                </div>
                <div className='product-desc mx-auto mt-5'>
                    <AccordionSection title="توضیحات">
                        {Product.description}
                    </AccordionSection>
                    <AccordionSection title="نحوه محاسبه قیمت">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                (نرخ طلای روز +۷٪ سود + اجرت
                                <br/>
                                - نرخ طلای روز + ۹٪مالیات +  نرخ طلای روز)
                                <br/>
                                *وزن طلا+ قیمت متعلقات
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="زمان ارسال">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال محصولات در شهر تهران از طریق پیک یا پست(به تشخیص دفتر مرکزی)انجام میگردد.کلیه ارسال ها از محدوده قیطریه انجام میشود.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از شعب تهران به آدرس تهران ۲۴ الی ۷۲ ساعت کاری انجام میگردد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از تهران به شهرستان هر یکشنبه و چهارشنبه با پست(در صورتی که سفارش ۴۸ ساعت قبل از روزهای ذکر شده ثبت شده باشد.)
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال از شعبه کرج به دیگر استان ها حدود دو هفته زمان میبرد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                مسئولیت ارسال های پستی با خریدار میباشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="هزینه ارسال">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                ارسال سفارشات بالای ۱۰ میلیون تومان
                                رایگان می باشد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                مسئولیت ارسال های پستی با خریدار میباشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                    <AccordionSection title="شرایط تعویض و مرجوعی کالا">
                        <p>
                        <ul>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                پس از ثبت سفارش امکان مرجوعی کالا وجود ندارد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                تعویض کالا تا ۲۴ ساعت بدون کسر از مبلغ فاکتور تا ۵ روز با کسر سود و مالیات بر ارزش افزوده انجام میگردد و پس از اتمام مدت مذکور کالا به صورت طلای خام از مشتری خریداری میگردد.
                            </li>
                            <li>
                                <i class="fto-ok fs_md mar_r4"></i>
                                سفارش شهرستان شامل قوانین تعویض کالا نمی باشد.
                            </li>
                        </ul>
                        </p>
                    </AccordionSection>
                </div>
                <div className="modal fade" id="galleryModal" tabIndex="-1" aria-labelledby="galleryModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-lg modal-dialog-centered">
                        <div className="modal-content">
                            <div className="modal-header">
                            <h5 className="modal-title" id="galleryModalLabel">گالری</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                            {/* اسلایدر Swiper داخل مودال */}
                            <Swiper
                                initialSlide={activeIndex}
                                navigation
                                pagination={{ clickable: true }}
                                modules={[Navigation, Pagination]}
                                className="swiper-container"
                            >
                                {Product.images.map((item, i) => (
                                <SwiperSlide key={i}>
                                   
                                    <img src={item.src} alt={`مدیا ${i + 1}`} className="img-fluid w-100" />
                                    
                                </SwiperSlide>
                                ))}
                            </Swiper>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        }
       </>
    );
});
export default ProductDetail;